// src/pages/docs/DocsSidebar.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Lean nav: conceptual guides plus the live Scalar API reference. The previous
// per-endpoint pages were retired in favour of the OpenAPI spec served from
// /api/openapi.json — that's the single source of truth.
const sections = [
  { label: 'Overview', path: 'overview' },
  { label: 'Getting Started', path: 'getting-started' },
  { label: 'Outreach API', path: 'getting-started#outreach', indent: true },
  { label: 'Reply Behaviour', path: 'getting-started#reply-behaviour', indent: true },
  { label: 'Flows API', path: 'getting-started#flows', indent: true },
  { label: 'Webhooks', path: 'getting-started#webhooks', indent: true },
  { label: 'Authentication', path: 'authentication' },
  { label: 'Try It (Sandbox)', path: 'try-it' },
  { label: 'API Reference', path: 'swagger' },
];

export default function DocsSidebar() {
  const location = useLocation();
  const basePath = '/integration-and-api';

  return (
    <div
      style={{
        padding: '20px',
        fontSize: '14px',
        backgroundColor: '#0f172a',
      }}
    >
      <Link
        to="/"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          color: '#94a3b8',
          textDecoration: 'none',
          fontSize: '13px',
          marginBottom: '16px',
        }}
      >
        <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z"
            clipRule="evenodd"
          />
        </svg>
        Back to App
      </Link>
      <h5 style={{ color: '#38bdf8', marginBottom: '20px' }}>API Documentation</h5>

      {sections.map((section) => {
        const [pathOnly] = section.path.split('#');
        const isActive =
          location.pathname === `${basePath}/${pathOnly}` ||
          (pathOnly === 'overview' && location.pathname === basePath);

        return (
          <Link
            key={section.path}
            to={section.path}
            style={{
              display: 'block',
              fontWeight: section.indent ? 'normal' : 'bold',
              marginBottom: section.indent ? '8px' : '14px',
              marginLeft: section.indent ? '12px' : '0',
              fontSize: section.indent ? '13px' : '14px',
              color: isActive ? '#38bdf8' : section.indent ? '#cbd5e1' : '#ffffff',
              textDecoration: 'none',
            }}
          >
            {section.label}
          </Link>
        );
      })}

      <p
        style={{
          marginTop: '32px',
          fontSize: '12px',
          color: '#94a3b8',
          lineHeight: '1.5',
        }}
      >
        The API Reference page loads the live OpenAPI spec from{' '}
        <code style={{ color: '#38bdf8' }}>/api/openapi.json</code> so it
        always reflects the latest endpoints.
      </p>
    </div>
  );
}
